import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

// Connects to data-controller="ui--datepicker"
export default class extends Controller {
  static targets = ["input"]
  static values = {
    options: Object,
  }

  connect() {
    const userOptions = this.optionsValue || {}

    const config = {
      // Flatpickr configuration
      dateFormat: userOptions.dateFormat || "Y-m-d",
      mode: userOptions.mode || "single",
      enableTime: userOptions.enableTime || false,
      allowInput: userOptions.allowInput !== false,
      clickOpens: userOptions.clickOpens !== false,

      // Date constraints
      minDate: userOptions.minDate || null,
      maxDate: userOptions.maxDate || null,

      // Localization
      locale: {
        firstDayOfWeek: 1, // Monday
      },

      // Styling - use @a-safe-digital theme colors
      onReady: (selectedDates, dateStr, instance) => {
        // Add custom class to calendar
        instance.calendarContainer.classList.add("flatpickr-calendar--custom")
      },

      // Handle disabled state
      ...(userOptions.clickOpens === false && { static: true }),

      // Time options
      ...(userOptions.enableTime && {
        enableTime: true,
        time_24hr: true,
        minuteIncrement: 1,
      }),
    }

    // Initialize Flatpickr
    this.flatpickr = flatpickr(this.inputTarget, config)

    // Handle disabled state
    if (this.inputTarget.disabled) {
      this.flatpickr.set("clickOpens", false)
    }

    // Add error class if needed
    if (this.inputTarget.hasAttribute("aria-invalid")) {
      this.element.classList.add("error")
    }
  }

  disconnect() {
    if (this.flatpickr) {
      this.flatpickr.destroy()
    }
  }

  // Clear the selected date
  clear() {
    if (this.flatpickr) {
      this.flatpickr.clear()
    }
  }

  // Open the calendar
  open() {
    if (this.flatpickr && !this.inputTarget.disabled) {
      this.flatpickr.open()
    }
  }

  // Close the calendar
  close() {
    if (this.flatpickr) {
      this.flatpickr.close()
    }
  }
}
